import { defineComponent as _defineComponent } from 'vue'
import { FromTo } from "@/types";
  import { computed } from "vue";
  import { numFormatter } from "@/helpers/transformation/number";

  interface Estate {
    title: string;
    logoUrl: string;
  }
  interface Props {
    lotSize: FromTo<number>;
    budget: FromTo<number>;
    estateId: Estate;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerDetailsCardWaitlist',
  props: {
    data: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  const getSize = computed(() => {
    const { from, to } = props.data.lotSize;

    return `${Number(from).toLocaleString()} m2 - ${Number(
      to
    ).toLocaleString()} m2`;
  });
  const getBudget = computed(() => {
    const { from, to } = props.data.budget;

    return `$${Number(from).toLocaleString()} - $${Number(
      to
    ).toLocaleString()}`;
  });

const __returned__ = { props, getSize, getBudget, get FromTo() { return FromTo }, computed, get numFormatter() { return numFormatter } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})